import './ReferralsCreateLink.sass';

import React, { FC } from 'react';
import { ScrollView, Header, FormItem, Button, Form, Input } from '$uikit';
import { createInviteLink, getDocumentHref } from '$utils';
import { useDispatch } from 'react-redux';
import { inviteActions } from '$store/invite';
import { toastActions } from '$store/toast';
import { useCurrentLang, useCurrentUserInfo, useTranslator } from '$hooks';
import { IcNewTab28 } from '$assets';

export const AFFILIATE_PROGRAM_PAGE_RU =
  'https://sarow.notion.site/Affiliate-Program-RU-1c921f62aad74c5f928c0df9d02762b1#a332da5b17354e719f80442036bca45f\n';
export const AFFILIATE_PROGRAM_PAGE_EN =
  'https://sarow.notion.site/Affiliate-Program-d332b69dabf544618e7540c007931d7d#4791b54694b64b9290340f1b2b581787';

export const ReferralsCreateLink: FC = () => {
  const [name, setName] = React.useState('');
  const [link, setLink] = React.useState('');
  const currentUser = useCurrentUserInfo();
  const { key: lang } = useCurrentLang();
  const disabled = useDispatch();
  const t = useTranslator();

  const handleCreateLink = () => {
    if (!name.length) {
      return disabled(toastActions.setToastFail(t('referrals_create_link_empty_name')));
    }
    if (!link.length) {
      return disabled(toastActions.setToastFail(t('referrals_create_link_empty_link')));
    }
    if (!createInviteLink(link, currentUser?.id, 0)) {
      return disabled(toastActions.setToastFail(t('referrals_create_link_invalid_link')));
    }
    disabled(
      inviteActions.createLink({
        userId: currentUser.id,
        name,
        link,
      }),
    );
  };

  return (
    <>
      <Header showCloseButton>{t('referrals_create_link_title')}</Header>
      <ScrollView>
        <Form>
          <FormItem title={t('referrals_create_link_field_name_label')}>
            <Input
              value={name}
              placeholder={t('referrals_create_link_field_name_placeholder')}
              onChange={(e) => setName(e.target.value)}
            />
          </FormItem>
          <FormItem
            title={t('referrals_create_link_field_url_label')}
            description={t('referrals_create_link_field_url_desc')}
          >
            <Input
              value={link}
              placeholder={t('referrals_create_link_field_url_placeholder')}
              onChange={(e) => setLink(e.target.value)}
            />
          </FormItem>
          <FormItem>
            <Button onClick={handleCreateLink}>
              {t('referrals_create_link_submit_button')}
            </Button>
          </FormItem>
          <FormItem
            description={
              <>
                {t('invite_terms_pref')}{' '}
                <a
                  href={getDocumentHref('terms', 'referrals')}
                  target="_blank"
                  rel="noreferrer"
                >
                  {t('invite_terms')}
                </a>
              </>
            }
          >
            <a
              href={lang === 'ru' ? AFFILIATE_PROGRAM_PAGE_RU : AFFILIATE_PROGRAM_PAGE_EN}
              target="_blank"
              rel="noreferrer"
            >
              <Button mode="secondary" iconRight={<IcNewTab28 />}>
                {t('referrals_create_link_promo_pages_urls')}
              </Button>
            </a>
          </FormItem>
        </Form>
      </ScrollView>
    </>
  );
};
